<div *ngIf="loading" style="text-align: center; margin:5px">
  <app-loading-spinner></app-loading-spinner>
</div>
<mat-card class="offer-ordered-overview-detail mt-2" *ngIf="order">
    <h3 *appApplyIfNotEmpty="translationService.getTranslation('offer_ordered_title')"
        [innerHTML]="translationService.getTranslation('offer_ordered_title')"></h3>
    <div [innerHTML]="translationService.getTranslation('offer_ordered_description')"></div>
    <div *ngIf="!isUserLoggedIn"
         [innerHTML]="translationService.getTranslation('offer_ordered_no_logged_in_user')"></div>
    <div id="orderConfirmation">
        <div id="orderConfirmationText" *ngIf="offer && offer.confirmationText"
             [innerHTML]="offer?.confirmationText"></div>
        <img id="orderConfirmationImage" class="w-50" *ngIf="offer && offer.confirmationImage"
             [ngSrc]="offer.confirmationImage.src"
             [width]="imageService.width"
             [height]="imageService.height"
             [priority]="true"
             [alt]="offer.confirmationImage.altText" fitImage>
    </div>
    <div class="row">
        <ng-container *ngIf="order.productDescription && order.variantDescription">
            <div class="col-6" [innerHTML]="translationService.getTranslation('order_object') + ' / ' + translationService.getTranslation('order_edition')"></div>
            <div class="col-6">{{order.productDescription}} / {{order.variantDescription}}</div>
        </ng-container>
        <ng-container>
            <div class="col-6" [innerHTML]="translationService.getTranslation('period')"></div>
            <div class="col-6">
              {{ !!order.validDate.validUntil ? '' : 'ab ' }}{{ order.validDate.validFrom | date }}
              {{ !!order.validDate.validUntil ? (' - ' + order.validDate.validUntil | date) : '' }}
            </div>
        </ng-container>
        <ng-container *ngIf="order.curDelivery">
            <div class="col-6" [innerHTML]="translationService.getTranslation('address_delivery')"></div>
            <div
                    class="col-6">{{order.curDelivery.person.addressCodeDescription}} {{order.curDelivery.person.firstname}} {{order.curDelivery.person.lastname}} {{order.curDelivery.address.street}} {{order.curDelivery.address.country === 'A' ? order.curDelivery.address.houseno + " " + order.curDelivery.address.stock + " " + order.curDelivery.address.stiege + " " + order.curDelivery.address.tuer : order.curDelivery.address.houseno}} {{order.curDelivery.address.zipcode}} {{order.curDelivery.address.city}}</div>
        </ng-container>
        <ng-container *ngIf="order.curBilling">
            <div class="col-6" [innerHTML]="translationService.getTranslation('address_billing')"></div>
            <div
                    class="col-6">{{order.curBilling.person.addressCodeDescription}} {{order.curBilling.person.firstname}} {{order.curBilling.person.lastname}} {{order.curBilling.address.street}} {{order.curBilling.address.country === 'A' ? order.curBilling.address.houseno + " " + order.curBilling.address.stock + " " + order.curBilling.address.stiege + " " + order.curBilling.address.tuer : order.curBilling.address.houseno}} {{order.curBilling.address.zipcode}} {{order.curBilling.address.city}}</div>
        </ng-container>
        <ng-container *ngIf="order.curPayment">
          <div class="col-6" [innerHTML]="translationService.getTranslation('payment_type')"></div>
          <div class="col-6">
            {{order.curPayment?.paymentType?.payMentMethodDescription }} / {{order.curPayment.paymentType.paymentFrequencyDescription}} <br>
            <ng-container *ngIf="order.curPayment?.bank?.swiftIBAN">
              {{translationService.getTranslation('payment_iban') + ': ' + order.curPayment.bank?.swiftIBAN | bankAccount }}
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="offer?.description">
          <div class="col-6 mb-4" [innerHTML]="translationService.getTranslation('order_product')"></div>
          <div class="col-6 mb-4" [innerHTML]="offer.description"></div>
        </ng-container>
        <ng-container *ngIf="price?.length > 0 || offer?.additionalPriceDescription?.length > 0">
          <div class="col-6" [innerHTML]="translationService.getTranslation('price')"></div>
          <ng-container *ngFor="let pricePart of price">
            <div *ngIf="offer?.priceCalculationActivated; else fixedPrice"
                 class="col-6">{{ pricePart?.price | number : '1.2-2'}} {{ pricePart.currency}}
              <div *ngIf="pricePart.porto" [innerHTML]="translationService.getTranslation('price_delivery') + ' ' + (pricePart?.porto | number : '1.2-2') + ' ' + pricePart.currency + ' ' + pricePart.portoDescription">
              </div>
            </div>
            <ng-template #fixedPrice>
              <div class="col-6">{{ pricePart?.priceText}}</div>
            </ng-template>
            <div class="col-6"></div>
          </ng-container>
          <div class="col-6" [innerHTML]="offer.additionalPriceDescription"></div>
        </ng-container>
        <ng-container *ngIf="order.selectedGiftList[0]?.name">
          <div class="col-6" [innerHTML]="translationService.getTranslation('gift_name')"></div>
          <div class="col-6">{{order.selectedGiftList[0].name}}</div>
        </ng-container>
        <ng-container *ngIf="order.commitmentDate">
          <div class="col-6" [innerHTML]="translationService.getTranslation('commitment_date')"></div>
          <div class="col-6">{{order.commitmentDate}}</div>
        </ng-container>
    </div>

    <ng-container *ngIf="timeUntilRedirectSeconds > 0 && redirectUrl?.length > 0">
        <div class="mt-3">
            Sie werden in {{timeUntilRedirectSeconds}} Sekunden weiter geleitet.
        </div>
    </ng-container>

    <ng-container>
        <div class="mt-3">
            <button mat-raised-button color="primary"
                    (click)="routeToOrderList()" [innerHTML]="translationService.getTranslation('button_go_to_subscription_overview')"></button>
        </div>
    </ng-container>

</mat-card>
